import Grid from '../../Common/Grid/index';
import React from 'react';
import Chip from '@material-ui/core/Chip';
import { getAccountId } from '../../../utils/firebase';
import BusinessIcon from '@material-ui/icons/Business';
import Tooltip from '@material-ui/core/Tooltip';
import { TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import PropTypes from 'prop-types';
import moment from 'moment';

import Cell from '../../Common/Grid/Cell';
import IdentityLabel from '../../Common/IdentityLabel';

import styles from './styles';
import getNoDataCellComponent from '../../Common/NoDataCellComponent/index';

const COLUMNS = [
  // { name: 'logo', title: ' ' },
  { name: 'name', title: 'Name' },
  { name: 'customerManager', title: 'Customer Manager' },
  { name: 'primaryContact', title: 'Primary Contact' },
  { name: 'tags', title: 'Tags' },
  { name: 'created', title: 'Created', visible: false },
  { name: 'updated', title: 'Updated' },
];

const COLUMN_EXTENSIONS = [
  // { columnName: 'logo', width: 70 },
  { columnName: 'name', width: 200 },
  { columnName: 'customerManager', width: 170 },
  { columnName: 'primaryContact', width: 170 },
  // { columnName: 'created', width: 120 },
  { columnName: 'updated', width: 120 },
  // { columnName: 'email', width: 150 },
];

const renderTag = (customerId, tag) => {
  return (<Chip
    style={styles.chip}
    key={`${customerId}-${tag}`}
    label={tag}
    color="secondary"
  />);
};

const getCellComponent = (showDialog) => ({ row, column, value }) => {
  switch (column.name) {
    case 'logo':
      return (value ? <img
        src={`https://assets.staza.io/accounts/${getAccountId()}/customers/logos/${value}?w=40&h=40`}
        height={40}
        width={40}
        alt="Customer Logo"
      /> : <BusinessIcon style={styles.business}/>);
    case 'customerManager':
      return value ? <IdentityLabel identity={value} showDialog={showDialog}/> : null;
    case 'primaryContact':
      const primaryContact = (row.contacts || []).find((c) => c.primary);
      return primaryContact ? <IdentityLabel identity={primaryContact} showDialog={showDialog}/> : null;
    case 'tags':
      return (value || []).map((tag) => renderTag(row.id, tag));
    case 'created':
      return value && value.at ? <div>
        <div>{moment(value.at).format('ll')}</div>
        <div>{moment(value.at).format('LT')}</div>
      </div> : '';
    case 'updated':
      return value && value.at ? moment(value.at).fromNow() : '';
    default:
      return value;
  }
};

const getFilterCellComponent = (fetchEmployees) => ({ column, children, ...other }) => {
  switch (column.name) {
    case 'name':
    // case 'customerManager':
    // case 'primaryContact':
      return (<TableFilterRow.Cell {...other} >{children}</TableFilterRow.Cell>);
    // case 'customerManager':
    //   console.log('other', other);
    //   return (<Cell {...other}>
    //     <EmployeeAutoComplete
    //       value={{}}
    //       onChange={(a, b, c) => console.log('change', a, b, c)}
    //       fetchEmployees={fetchEmployees}
    //     />
    //   </Cell>);
    default:
      return <Cell/>;
  }
};

// const noDataCellComponent = ({ tableRow, children }) => {
//   return (<TableCell colSpan={children.length} style={styles.noDataRow}>
//
//     <div style={styles.noDataText}>No customers are available</div>
//   </TableCell>);
// };

// renderNoData() {
//   return (<TableRow key="nodata">
//     <TableCell colSpan={4} style={styles.noDataRow}>
//       <BusinessIcon style={styles.noData}/>
//       <div>No customers are available</div>
//     </TableCell>
//   </TableRow>);
// }

const noDataCellComponent = getNoDataCellComponent(<BusinessIcon style={styles.noData}/>, 'customers');

const CustomersGrid = ({ data, fetch, onAdd, onEdit, onRemove, showDialog, fetchEmployees }) => {
  const buttons = onAdd ? [<Tooltip key="create" title="Add Customer">
    <Fab
      color="secondary"
      aria-label="add"
      style={styles.add}
      onClick={onAdd}
      id="addContact"
    >
      <AddIcon/>
    </Fab>
  </Tooltip>] : [];

  return (<div>
    <Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent(showDialog)}
      filterCellComponent={getFilterCellComponent(fetchEmployees)}
      fetch={fetch}
      data={data}
      noDataCellComponent={noDataCellComponent}
      onEdit={onEdit}
      onRemove={onRemove}
      allowSorting
      sorting={[{ columnName: 'updated', direction: 'desc' }]}
    />
  </div>);
};

CustomersGrid.propTypes = {
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  data: PropTypes.object,
  fetch: PropTypes.func,
  fetchEmployees: PropTypes.func,
};

export default CustomersGrid;



// WEBPACK FOOTER //
// ./src/components/Customers/CustomersGrid/index.js